export function formatURL(url: string, objFmt: Record<string, string>): string {
  for (const key in objFmt) {
    url = url.replace(`:${key}`, objFmt[key]);
  }
  return url;
}

export function convertKeysToSnakeCase<T extends Record<string, any>>(
  obj: T,
  preserveConsecutiveUppercase: boolean = false,
): T {
  const camelToSnakeCase = (str: string) => {
    if (!preserveConsecutiveUppercase) {
      return str
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
        .replace(/([a-z\d])([A-Z])/g, '$1_$2')
        .toLowerCase();
    }
    
    return str
      // Handle acronyms followed by PascalCase: ABCDef -> ABC_Def
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
      // Handle lowercase/digit followed by uppercase: fooBar -> foo_Bar
      .replace(/([a-z\d])([A-Z])/g, '$1_$2')
      // Split by underscores and process each segment
      .split('_')
      .map(segment => {
        // If segment contains both uppercase and lowercase, convert all to lowercase
        const hasUppercase = /[A-Z]/.test(segment);
        const hasLowercase = /[a-z]/.test(segment);
        
        if (hasUppercase && hasLowercase) {
          // Mixed case: convert to lowercase (e.g., "Id" -> "id")
          return segment.toLowerCase();
        } else if (hasUppercase) {
          // All uppercase: preserve (e.g., "TSA" -> "TSA", "A" -> "A")
          return segment;
        } else {
          // All lowercase or numbers: keep as is
          return segment;
        }
      })
      .join('_');
  };

  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => convertKeysToSnakeCase(item, preserveConsecutiveUppercase)) as unknown as T;
  }

  return Object.keys(obj).reduce((acc, key: string) => {
    const snakeCaseKey = camelToSnakeCase(key);
    const value = obj[key];
    const convertedValue = convertKeysToSnakeCase(value, preserveConsecutiveUppercase);
    return { ...acc, [snakeCaseKey]: convertedValue };
  }, {} as T);
}

export const modifyNumberedLists = (text: string) => {
  const regex = /^(\d+)[\)\.]\s/gm;
  return text.replace(regex, "$1.) ");
};